import { render, staticRenderFns } from "./shop_brands.vue?vue&type=template&id=50fc0126&scoped=true"
import script from "./shop_brands.vue?vue&type=script&lang=js"
export * from "./shop_brands.vue?vue&type=script&lang=js"
import style0 from "./shop_brands.vue?vue&type=style&index=0&id=50fc0126&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fc0126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50fc0126')) {
      api.createRecord('50fc0126', component.options)
    } else {
      api.reload('50fc0126', component.options)
    }
    module.hot.accept("./shop_brands.vue?vue&type=template&id=50fc0126&scoped=true", function () {
      api.rerender('50fc0126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/custom-layout/components/centerModule/shop_brands.vue"
export default component.exports